import ArrowRightBlue from '../../../static/svg/arrow-right-blue.svg';
import React from 'react';
import * as styles from './arrow.module.scss';

interface Props {
  color: string;
}

export const Arrow: React.FC<Props> = ({ color }) => {
  return (
    <div className={styles.wrapper} data-type={color}>
      <ArrowRightBlue />
    </div>
  );
};
